import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, Page } from "components";
import { useApp, useSession, useTheme } from "contexts";
import { Helpers, Routes } from "utils";
import { useNavigate } from "react-router-dom";
import { usePotluck } from "hooks";
import { Combines } from "helpers";

type Props = {};

export const Invitee = (props: Props) => {
  const navigate = useNavigate();

  const { potluck, token } = usePotluck();

  const { t } = useApp();
  const { theme } = useTheme();
  const { isAuthenticated } = useSession();

  if (!potluck) return <Page.Loader />;

  return (
    <Box pt={theme.spacing.sm}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box py={theme.spacing.xxxl}>
                <Stack spacing={theme.spacing.sm}>
                  <Stack spacing={theme.spacing.sm}>
                    <Custom.Typography
                      size={theme.font.lg}
                      weight={theme.font.bold}
                    >
                      {t.page.invitee.header}
                    </Custom.Typography>
                    <Custom.Typography
                      size={theme.font.sm}
                      weight={theme.font.bold}
                    >
                      {t.page.invitee.subheader}
                    </Custom.Typography>
                  </Stack>

                  <Stack spacing={theme.spacing.xxs}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={theme.spacing.md}
                    >
                      <Custom.Typography
                        size={theme.font.xxs}
                        weight={theme.font.bold}
                      >
                        {t.label.when}
                      </Custom.Typography>
                      <Custom.Typography size={theme.font.sm}>
                        {potluck.date}
                      </Custom.Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={theme.spacing.md}
                    >
                      <Custom.Typography
                        size={theme.font.xxs}
                        weight={theme.font.bold}
                      >
                        {t.label.start_time}
                      </Custom.Typography>
                      <Custom.Typography size={theme.font.sm}>
                        {potluck.start_time}
                      </Custom.Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={theme.spacing.md}
                    >
                      <Custom.Typography
                        size={theme.font.xxs}
                        weight={theme.font.bold}
                      >
                        {t.label.end_time}
                      </Custom.Typography>
                      <Custom.Typography size={theme.font.sm}>
                        {potluck.end_time}
                      </Custom.Typography>
                    </Stack>
                  </Stack>
                  <Custom.Typography
                    component="pre"
                    size={theme.font.sm}
                    sx={{ whiteSpace: "pre-line" }}
                  >
                    {potluck.message}
                  </Custom.Typography>
                  <Stack spacing={theme.spacing.sm}>
                    <Custom.Button
                      variant="contained"
                      trailing="right"
                      onClick={() =>
                        navigate(
                          Helpers.encodedUrl(Routes.usercontributor, {
                            id: potluck._id,
                          })
                        )
                      }
                    >
                      {t.page.invitee.button_action}
                    </Custom.Button>
                    {!isAuthenticated && (
                      <Custom.Button
                        variant="outlined"
                        trailing="right"
                        onClick={() =>
                          navigate(
                            Combines.interpolateURL(Routes.useronboarding, {
                              token: token,
                            })
                          )
                        }
                      >
                        {t.button.create_user}
                      </Custom.Button>
                    )}
                  </Stack>
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                top: 0,
                display: { xs: "none", md: "flex" },
                height: "100vh", // Ensures it takes up full height
                position: "sticky",
                overflow: "hidden", // Prevents internal scrolling
                alignItems: "center", // Centers image if needed
                justifyContent: "center",
              }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
        <Common.Footnote />
      </Stack>
    </Box>
  );
};
